<template>
<v-content class="download-print-resume">
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <v-btn class="mr-2" color="primary" outlined v-on="on" tile href="ressources/joseph_perrin_resume.pdf" download="joseph_perrin_resume.pdf">Download</v-btn>
    </template>
    <span>Download my resume</span>
  </v-tooltip>


</v-content>
</template>
<script>
export default {
  name: 'DownloadResume',
}
</script>
